/**
 * Cache identity for AI Providers.
 *
 * Mirrors `llm-profiles/queryKeys.ts`: typed factories rather than inline
 * arrays so the query and every invalidation that follows a mutation cannot
 * drift apart (constitution §2.6).
 */
export const aiProviderKeys = {
  all: () => ['ai-providers'] as const,
  list: () => ['ai-providers', 'list'] as const,
  detail: (id: string) => ['ai-providers', 'detail', id] as const,
};
